import React from "react"
import PropTypes from "prop-types"
import FeaturesTileText from "./FeaturesTileText"

const FeaturesTile = ({ imgSrc, imgTitle, imgAlt, tileTitle }) => {
  return (
    <>
      <article
        className="tile is-child"
        style={{ marginBottom: "0.5rem !important" }}
      >
        <h3 className="has-text-centered has-text-primary has-text-weight-bold is-size-4-mobile is-size-4-tablet is-size-3-widescreen">
          {tileTitle}
        </h3>
      </article>

      <div className="tile is-child"></div>

      <article className="tile is-child has-text-centered">
        <img title={imgTitle} alt={imgAlt} src={imgSrc} />
      </article>

      <div className="tile is-child"></div>

      <article className="tile is-child has-text-centered">
        <FeaturesTileText tileTitle={tileTitle} />
      </article>
    </>
  )
}

FeaturesTile.propTypes = {
  imgSrc: PropTypes.any,
  imgTitle: PropTypes.string,
  imgAlt: PropTypes.string,
  tileTitle: PropTypes.string,
}

export default FeaturesTile
